import * as React from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  Typography,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/InfoOutline';
import { withStyles } from '@material-ui/core/styles';
import history from '../../../history/browserHistory';
import DataSharingHelper from '../helpers/DataSharingHelper';
import DateHelper from '../helpers/DateHelper';
import { Status } from '../../shared/constants';
import * as moment from 'moment';
import { getCurrencySymbol } from "../helpers/CurrencyHelper";

const styles = {
  table: {
    padding: 24,
    paddingTop: 0,
  },
  tableHead: {
    '& th': {
      width: '16.67%',
    },
  },
  tableRow: {
    height: 40,
  },
  status: {
    display: 'flex',
    alignItems: 'center',

    '& > svg': {
      paddingRight: 5,
    },
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  fee: {
    paddingRight: 30,
  },
};

const stylesHOF = withStyles(styles);

function AssetDataTableHOC(Label: any, DataProperty: any) {
  class AssetDataTable extends React.Component<any, any> {
    public getFeesTotal = (agreement: any) => {
      return Object.values(
          agreement.fees.reduce((acc: any, curr: any) => {
          if (!acc[curr.id]) {
            acc[curr.id] = { unit: curr.unit, total: 0 };
          }
          acc[curr.id].total += curr.amount;
          return acc;
        }, {})
      )
        .map((fee: any) => `${getCurrencySymbol(agreement.currency)} ${DataSharingHelper.RoundFee(fee.total)} ${fee.unit}`)
        .join(' + ');
    };

    public renderState = (state: any) => {
      const { classes } = this.props;

      if (state.remark) {
        return (
          <Tooltip title={state.remark} placement="bottom-start">
            <Typography className={classes.status}>
              <InfoIcon color="secondary" />
              {Label.Status[state.id]}
            </Typography>
          </Tooltip>
        );
      }

      return <Typography>{Label.Status[state.id]}</Typography>;
    };
    public endDate = (beginDate: string, durationMonths: number) => {
      if (beginDate && moment(beginDate).isValid() && durationMonths && durationMonths > 0) {
        let endDate = moment(beginDate)
        while (!moment().isBefore(endDate)) {
          endDate = endDate.add(durationMonths, 'M')
        }
        return moment(endDate).format("DD MMM YYYY")
      }
      return ""
    }
    public countdownToEndDate = (beginDate: string, durationMonths: number) => {
      const endDate = moment(this.endDate(beginDate, durationMonths))
      if (endDate.isValid()) {
        return moment(endDate).fromNow()
      }
      return ""
    }
    public renderAgreement = (agreement: any) => {
      const { basePath, classes } = this.props;
      return (
        <TableRow hover tabIndex={-1} key={agreement.id} className={classes.tableRow}>
          <TableCell padding="none">
            {DateHelper.FormatDate(agreement.states[0].date)}
          </TableCell>
          <TableCell padding="none">{agreement[DataProperty.Entity].entity.name}</TableCell>
          <TableCell padding="none">{this.renderState(agreement.states[0])}</TableCell>
          <TableCell padding="none" className={classes.fee}>
            {this.getFeesTotal(agreement)}
          </TableCell>
          {this.props.view.some((status: string) => status === Status.Accepted) &&
            <TableCell padding="none">{this.countdownToEndDate(agreement.startDate, agreement.durationMonths)}</TableCell>
          }
          {this.props.view.some((status: string) => status === Status.Suspended || status === Status.Expiring) &&
            <TableCell padding="none">{this.endDate(agreement.startDate, agreement.durationMonths)}</TableCell>
          }
          <TableCell
            padding="none"
            onClick={() => {
              history.push(basePath + '/' + agreement.id);
            }}
            className={classes.link}
          >
            {Label.Action[agreement.states[0].id]}
          </TableCell>
        </TableRow>
      );
    };

    public render() {
      const { agreements, classes } = this.props;
      return (
        <div className={classes.table}>
          <Table aria-labelledby="tableTitle">
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell padding="none">Date</TableCell>
                <TableCell padding="none">
                  {DataSharingHelper.CapitalizeString(Label.Entity.Name)}
                </TableCell>
                <TableCell padding="none">Status</TableCell>
                <TableCell padding="none">Fee</TableCell>
                {this.props.view.some((status: string) => status === Status.Accepted) &&
                  <TableCell padding="none">Renewal</TableCell>
                }
                {this.props.view.some((status: string) => status === Status.Expiring || status === Status.Suspended) &&
                  <TableCell padding="none">End date</TableCell>
                }
                <TableCell padding="none">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{agreements.map(this.renderAgreement)}</TableBody>
          </Table>
        </div>
      );
    }
  }

  return stylesHOF(AssetDataTable);
}

export default AssetDataTableHOC;



// WEBPACK FOOTER //
// ./src/modules/shared/dataSharing/AssetDataTable.tsx